module.exports = __webpack_public_path__ + "img/scatter.0dd1c537.png";